import React from "react";
import { useTranslation } from "react-i18next";

import {
  ChevronDown,
  FileEarmark,
  Folder,
  PlusLg,
  Star,
} from "react-bootstrap-icons";

import { Dropdown } from "react-bootstrap";

import Breadcrumb from "../../components/breadcrumb";
import useGetUrlLocale from "../../hooks/useGetUrlLocale";
import { useIsNoShared } from "../../hooks/useIsNoShared";
import { Link, useParams } from "react-router-dom";
import { useUserQuery } from "../../graphql/menu.hooks";
import { isShowNewProjectModal } from "../../graphql/state";

interface IProps {
  projectAccessType?: number | string;
  accessType?: number | string;
  title: string;
  paths: Array<{
    path: string;
    label: string;
  }>;
  isHiddenDropdown?: boolean;
  isHiddenTryPro?: boolean;
  isProjects?: boolean;
}
const PageHeader: React.FC<IProps> = ({
  title,
  paths,
  projectAccessType,
  accessType,
  isHiddenDropdown = false,
  isHiddenTryPro = false,
  isProjects = false,
}) => {
  const { t } = useTranslation();
  const lng = useGetUrlLocale();
  const { projectId, id } = useParams();
  const isNoShared = useIsNoShared();

  const { data: userData, loading } = useUserQuery();

  const createFolderLink = id
    ? `${lng}/folder/new?parentFolder=${id}`
    : `${lng}/folder/new?parentDomain=${projectId}`;
  return (
    <>
      <div className="d-lg-flex justify-content-between align-items-center mb-4 text-break">
        <div className="mb-4 mb-lg-0">
          <h1>{t(title)}</h1>
          <Breadcrumb t={t} paths={paths} />{" "}
        </div>
        {(isHiddenTryPro &&
          !userData?.user?.admin &&
          !userData?.user?.activePremium) ||
          (!loading && (
            <div className="d-flex col-12 col-lg-8 me-0 row ms-0 justify-content-end">
              {
                <div className={`headingBtn col-6 align-self-center pe-2 ps-0`}>
                  <button
                    onClick={() =>
                      (window.location.href = `${process.env.REACT_APP_ME_PAGE_URL}${lng}/pricing/#pricingSection`)
                    }
                    className="col-12 btn btn-outline-primary text-primary fw-normal text-nowrap primary-hover d-flex align-items-center justify-content-center"
                  >
                    <Star className="fs-6 me-2" />
                    <p className="m-0 d-none d-lg-block">
                      {t("modal.Try Pro Version*")}
                    </p>
                    <p className="m-0 d-block d-lg-none">
                      {t("modal.Try Pro*")}
                    </p>
                  </button>
                  <p className="mt-2 mb-0 fs-9 text-primary text-center text-capitalize">
                    {t("modal.*All Pages Ads-free")}
                  </p>
                </div>
              }
              <div
                className={`${`${isHiddenDropdown ? "d-none" : "d-block"}`} headingBtn ${isHiddenTryPro || userData?.user?.activePremium ? "col-12 ps-0" : "col-6 ps-2"} pe-0`}
              >
                <Dropdown>
                  <Dropdown.Toggle
                    variant="primary"
                    id="dropdown-basic"
                    className="text-white fs-7 w-100 fw-normal d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <PlusLg className="me-2" />
                      <span>{t("projects.create")}</span>
                    </div>
                    <ChevronDown />
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="w-100 fs-7">
                    {userData?.user?.domains.length > 0 && (
                      <Dropdown.Item
                        as={Link}
                        to={{
                          pathname: `${lng}/page/create`,
                          search: `?type=1${id ? `&parentFolder=${id}` : ""}${projectId ? `&projectId=${projectId}` : isProjects ? `&projectId=${userData?.user?.domains[0]?.id}` : ""}${!isNoShared && !isProjects ? `&Shared` : ""}`,
                        }}
                        className="py-2 px-3 mb-1"
                        onClick={() => {
                          window.gtag?.("event", "create_page");
                        }}
                      >
                        <FileEarmark className="me-2" />
                        {t("menu.page")}
                      </Dropdown.Item>
                    )}
                    {projectId &&
                      (projectAccessType === 2 || !projectAccessType) &&
                      (accessType !== 1 || !accessType) && (
                        <>
                          <Dropdown.Item
                            as={Link}
                            className=" py-2 px-3 mb-1"
                            to={createFolderLink}
                            onClick={() => {
                              window.gtag?.("event", "create_folder");
                            }}
                          >
                            <Folder className="me-2" />
                            {t("projects.folder")}
                          </Dropdown.Item>
                        </>
                      )}
                    <Dropdown.Item
                      className=" py-2 px-3 mb-1"
                      onClick={() => {
                        isShowNewProjectModal(true);
                        window.gtag?.("event", "create_project");
                      }}
                    >
                      <Star className="me-2" />
                      {t("projects.project")}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          ))}
      </div>
    </>
  );
};
export default PageHeader;
